export const MBE_NOTIFICATION_LETTERS_GET_CALENDARS =
  'MBE_NOTIFICATION_LETTERS_GET_CALENDARS';
export const MBE_NOTIFICATION_LETTERS_ERROR = 'MBE_NOTIFICATION_LETTERS_ERROR';
export const MBE_NOTIFICATION_LETTERS_LOADING =
  'MBE_NOTIFICATION_LETTERS_LOADING';
export const MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE =
  'MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE';
export const MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE_ALL =
  'MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE_ALL';
export const MBE_NOTIFICATION_LETTERS_PROCESS_LETTERS =
  'MBE_NOTIFICATION_LETTERS_PROCESS_LETTERS';
export const MBE_NOTIFICATION_LETTERS_GET = 'MBE_NOTIFICATION_LETTERS_GET';
export const MBE_NOTIFICATION_LETTERS_GET_BAD_EMAILS =
  'MBE_NOTIFICATION_LETTERS_GET_BAD_EMAILS';
export const MBE_NOTIFICATION_LETTERS_CLEAR_BAD_EMAILS =
  'MBE_NOTIFICATION_LETTERS_CLEAR_BAD_EMAILS';



// WEBPACK FOOTER //
// ./src/pages/mbenotification/state/letters/types.js